import React, { useState, useEffect } from "react";
import axios from "axios";
import { Radio, Table, Input, DatePicker, Modal, Card, Row, Col, Space, Image, Checkbox, Button, message } from "antd";
import { Link, useParams, useNavigate } from "react-router-dom";
import moment from "moment";
import { ConsoleSqlOutlined, PlusOutlined, EditOutlined, CloseCircleOutlined } from "@ant-design/icons";
import AdminEnvironmentModal from "./components/AdminEnvironmentModal";
const { RangePicker } = DatePicker;
const AdminAppointment = () => {
    
    return (
        <>
        </>
    )
}
export default AdminAppointment;